import { motion } from "framer-motion";
import { Reveal, Overline } from "./Reveal";
import { SERVICES } from "../data/content";

export const Services = () => (
  <section
    id="services"
    className="relative border-y border-white/5 bg-[#101010]"
    data-testid="services-section"
  >
    <div className="mx-auto max-w-[1400px] px-6 py-28 lg:px-10 lg:py-40">
      <div className="mb-16 max-w-2xl">
        <Reveal>
          <Overline>{SERVICES.overline}</Overline>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-serif text-4xl tracking-tight text-white sm:text-5xl">
            {SERVICES.title}
          </h2>
        </Reveal>
      </div>

      <div className="border-t border-white/10">
        {SERVICES.items.map((s, i) => (
          <motion.div
            key={s.no}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.7, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
            className="group grid grid-cols-12 items-center gap-4 border-b border-white/10 py-8 transition-colors duration-500 hover:bg-white/[0.02]"
            data-testid={`service-${s.no}`}
          >
            <span className="col-span-2 font-serif text-lg italic text-zinc-600 lg:col-span-1">
              {s.no}
            </span>
            <h3 className="col-span-10 font-serif text-2xl text-white transition-colors duration-300 group-hover:text-gold sm:text-3xl lg:col-span-5">
              {s.name}
            </h3>
            <p className="col-span-12 text-base leading-relaxed text-zinc-400 lg:col-span-6">
              {s.body}
            </p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
